import React, { FunctionComponent } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/icons/Menu';

const MenuIcon: FunctionComponent = () => {
  const name = localStorage.getItem('name') ? localStorage.getItem('name') : '';
  return (
    <div>
      <div className="menu-item-wrapper">
        <IconButton className="menu-icon-wrapper">
          <Menu htmlColor="#000000" />
        </IconButton>
        <p className="name heading">{name || 'Guest'}</p>
      </div>
    </div>
  );
};

export default MenuIcon;
